import { STARTED } from 'src/services/constants/activites';
import { createCoLoanInNamespace } from 'src/services/loanClone/loanClone';
import { mkMortgageCoLoanInNamespace } from 'src/services/objects/loanApp';
import { handleInitCurrentLoanContext } from 'src/store/authentication/authentication.actions';
import { mkCoLoanContext } from './init_loan';
import { ENTITY_ALL } from 'src/services/constants';
/**
 * createMortageLoan
 *
 * Creates a mortgage loan in the namespace
 *
 * The following are created
 *
 * 1. Create  Loan
 * 2. Set context in the  session
 *
 * @param onCreated { HOC function } The higher order function to call onCreated.
 * @param onFailure { HOC function } The higher order function to call on
 * Failure.
 **
 */
export const createCoMortgageLoan = async (
  data: any,
  history: any,
  dispatch: any,
  onCreateAudit: any,
  onCreated: any
) => {
  const { accountId, loanId, accountEmail } = data;
  const loan = mkMortgageCoLoanInNamespace(accountId);
  const res = await createCoLoanInNamespace(loan, loanId, ENTITY_ALL);
  onCreated(res)
  const loanContext = mkCoLoanContext(res, accountEmail);
  await onCreateAudit(
    loanId,
    `${accountEmail}`,
    STARTED,
    'the application',
    'as co-applicant',
    ''
  );

  await dispatch(handleInitCurrentLoanContext(loanContext));
};

export const decodeLoanData = (data: string) => {
  if (data) {
    const decodedData = window.atob(data);
    return JSON.parse(decodedData.replace(/'/g, '"'));
  }
};
